import * as Yup from 'yup';

const INITIAL_VALUES = {
  amount: '',
};

const VALIDATION_SCHEMA = Yup.object().shape({
  amount: Yup.string().trim().required('Purchasing limit is required.'),
});

export { INITIAL_VALUES, VALIDATION_SCHEMA };
